<template>
  <div>
    <h1 class="mb-8 font-bold text-3xl">
      <span class="text-indigo-400 font-small">Datos </span>del Proyecto
    </h1>
      <form @submit.prevent="store">
        
         <div class="bg-white rounded-md shadow overflow-hidden max-w-3xl" style="margin: 15px;">
          <div class="p-8 -mr-6 -mb-8 flex flex-wrap">
            <text-input v-model="form.project" :error="form.errors.project" class="pr-6 pb-8 w-full lg:w-2/6" label="Proyecto" required/>
            <text-input v-model="form.cliente" :error="form.errors.cliente" class="pr-6 pb-8 w-full lg:w-4/6" label="Nombre Cliente" required/>
            <text-input v-model="form.manzana" :error="form.errors.manzana" class="pr-6 pb-8 w-full lg:w-1/6" label="Manzana" required/>
            <text-input v-model="form.lote" :error="form.errors.lote" class="pr-6 pb-8 w-full lg:w-1/6" label="Lote" required/>
            <text-input :type="number" v-model="form.area" :error="form.errors.area" class="pr-6 pb-8 w-full lg:w-1/6" label="Área m2" required/>
            <text-input v-model="form.costo_m2" :error="form.errors.costo_m2" class="pr-6 pb-8 w-full lg:w-1/6" label="Costo m2" disabled/>
            <text-input v-model="form.entrada" :error="form.errors.entrada" class="pr-6 pb-8 w-full lg:w-2/6" label="Entrada" required/>
            <text-input v-model="form.tasa" :error="form.errors.tasa" class="pr-6 pb-8 w-full lg:w-1/6" label="Tasa" required/>
            <text-input v-model="form.descuento" :error="form.errors.descuento" class="pr-6 pb-8 w-full lg:w-1/6" label="Descuento" required/>
            <text-input v-model="form.plazo" :error="form.errors.plazo" class="pr-6 pb-8 w-full lg:w-1/6" label="Plazo" required/>
            <select-input v-model="form.ver" :error="form.errors.ver" class="pr-6 pb-8 w-full lg:w-1/6" label="Tabla" required>
            <option>SI</option>
            <option>NO</option>
           
          </select-input>
          <select-input v-model="form.simple" :error="form.errors.simple" class="pr-6 pb-8 w-full lg:w-2/6" label="Forma" required>
            <option>Simple</option>
            <option>Detallada</option>
           
          </select-input>
                      
          
            <br>
                      <br>
        </div>
         </div>
        <div class="px-8 py-4 bg-gray-50 border-t border-gray-100 flex justify-end items-center">
          <loading-button :loading="form.processing" class="btn-indigo" type="submit">Generar</loading-button>
        </div>
      </form>
  </div>
</template>

<script>
import Vue from 'vue'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import LoadingButton from '@/Shared/LoadingButton'
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import axios from 'axios'
import VueAxios from 'vue-axios'
import SelectInput from '@/Shared/SelectInput'

export default {
  metaInfo: { title: 'Cliente' },
  components: {
    LoadingButton,
    vSelect,
    TextInput,
    SelectInput,
    axios,
    VueAxios,
    Vue,
  },
  layout: Layout,
  props: {
    project: Object,
    tipo: Object,
  },
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        cliente: null,
        project_id: this.project.id,
        manzana: null,
        lote: null,
        area: this.tipo.area_minima,
        costo_m2: this.tipo.costo_m2,
        project: this.project.nombre,
        entrada: this.tipo.entrada,
        tasa: this.tipo.tasa_financiamiento,
        descuento: null,
        plazo: null,
        ver: 'NO',
        simple: 'Detallada',
      }),
      imagenminiatura: '',
    }
  },
  mounted(){
   
  },
  methods: {
    store() {
      this.form.post(this.route('cotizadors.store'))
    },
    cambia(){
      
    }
  },
}
</script>
